import { render, staticRenderFns } from "./DatasetMetadataForm.vue?vue&type=template&id=41b83588"
import script from "./DatasetMetadataForm.vue?vue&type=script&lang=js"
export * from "./DatasetMetadataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports